module.exports = __webpack_public_path__ + "media/images/svg/realestate/beach-house-2df07430515d934c9083ca87e16e118f.svg";